import React, { Component } from 'react'
import { connect } from 'react-redux'

import { loadFilters, setSelectedFilters } from '../../../redux/jewels/actions';
import { Tooltip } from 'react-tippy';

import classes from './JewelsFilters.module.scss';


import Select from 'react-select'

import _ from 'lodash';
const customStyles = {
    input: () => ({ margin:0, padding:0 }),
    control: (provided) => ({  ...provided, minHeight:36 }),
}

class JewelsFilters extends Component {

    componentDidMount(){
        this.props.loadFilters();
    }

    handleSelectChange = (filtername, newValue) => {
       this.props.setSelectedFilters(filtername, newValue)
    };
   

    render() {

        return(
            <div className={classes.Toolbar}>
            <label>Search <Tooltip title={this.props.termes.application.membreTootltipJewelsSearch}><img src={ require('../../../assets/img/tooltip.svg')} /></Tooltip></label>
            <Select styles={customStyles}  styles={{menu: (styles) => Object.assign(styles, {zIndex: 1000})}} options={ this.props.filters.tags} value={ this.props.selectedfilters.tags } onChange={ (newValue) => this.handleSelectChange('tags', newValue) } isMulti isSearchable isClearable />
            </div>
        );
    }
}

const mapStateToProps = (state)=>{
    return {
      filters: state.jewels.filters,
      selectedfilters: state.jewels.selectedfilters,
      termes: state.settings.termes
    }
  };

export default connect(mapStateToProps, { loadFilters, setSelectedFilters})(JewelsFilters);
